//import Config from "react-native-config";

const keys = {
  googleMaps: process.env.REACT_APP_GOOGLE_API_KEY,
  //firebase: Config.FIREBASE_API_KEY,
  // ... otras claves
};
export default keys;
